<template>
  <button class="btn btn-success mb-4" data-bs-toggle="offcanvas" data-bs-target="#userOffcanvas">
    Προσθήκη μέλους
  </button>
  <p v-if="users.length === 0"><i class="fa-solid fa-triangle-exclamation text-danger"></i> <strong>Δεν υπάρχουν καταχωρημένα μέλη για αυτο το φαρμακείο.</strong></p>
  <div v-if="users.length !== 0" class="p-6">
    <div class="table-responsive">
      <table class="table bg-white table-striped table-hover">
        <thead>
          <tr>
            <th class="py-2 px-4">α/α</th>
            <th class="py-2 px-4">Όνομα</th>
            <th class="py-2 px-4">Email</th>
            <th class="py-2 px-4">Κινητό</th>
            <th class="py-2 px-4">Λήγει</th>
            <th class="py-2 px-4">Ενέργειες</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(user, i) in users" :key="user.id" class="border-b">
            <td class="py-2 px-4">{{ i+1 }}</td>
            <td class="py-2 px-4">{{ user.display_name }}</td>
            <td class="py-2 px-4">{{ user.email }}</td>
            <td class="py-2 px-4">{{ user.mobile || '-' }}</td>
            <td class="py-2 px-4">{{ user.expires_at_for_humans || '-' }} <span v-if="user.expired" class="badge text-bg-danger text-white">Έληξε</span></td>
            <td class="py-2 px-4">
              <button
                class="btn btn-outline-danger btn-sm"
                v-on:click="confirmDelete(user.id)"
              >
                Διαγραφή
              </button>
              <button
                class="btn btn-outline-primary btn-sm ms-2"
                v-if="user.expired"
                v-on:click="confirmReactivate(user.id)"
              >
                Ενεργοποίηση
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="deleteModal"
      tabindex="-1"
      aria-labelledby="deleteModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteModalLabel">Επιβεβαίωση Διαγραφής</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            Θέλετε σίγουρα να διαγράψετε το μέλος του Φαρμακείου σας;
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Επιστοφή
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="deleteUser"
              data-bs-dismiss="modal"
            >
              Ναι, να διαγραφεί
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="reactivateModal"
      tabindex="-1"
      aria-labelledby="reactivateModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteModalLabel">Ενεργοποίηση Μέλους</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            Θέλετε σίγουρα να ενεργοποιήσετε ξανά το μέλος του Φαρμακείου σας;
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Επιστοφή
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="reactivateUser"
              data-bs-dismiss="modal"
            >
              Ναι, να ενεργοποιηθεί
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Offcanvas Component -->
  <div class="offcanvas offcanvas-end" tabindex="-1" id="userOffcanvas" aria-labelledby="userOffcanvasLabel">
    <div class="offcanvas-header">
      <h5 id="userOffcanvasLabel">Προσθήκη νέου μέλους</h5>
      <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <form class="needs-validation mb-3" @submit.prevent="submitForm">
        <div class="has-validation mb-3">
          <label for="name" class="form-label">Όνομα</label>
          <input type="text" class="form-control" :class="{ 'is-invalid': errors.first_name}" name="first_name" id="first_name" v-model="newUser.first_name" placeholder="π.χ. Γιάννης" required>
          <div class="invalid-feedback" v-if="errors.first_name">{{ errors.first_name[0] }}</div>
        </div>

        <div class="has-validation mb-3">
          <label for="name" class="form-label">Επίθετο</label>
          <input type="text" class="form-control" :class="{ 'is-invalid': errors.last_name}" name="last_name" id="last_name" v-model="newUser.last_name" placeholder="π.χ. Καραγιάννης" required>
          <div class="invalid-feedback" v-if="errors.last_name">{{ errors.last_name[0] }}</div>
        </div>

        <div class="has-validation mb-3">
          <label for="email" class="form-label">Email</label>
          <input type="email" class="form-control" :class="{ 'is-invalid': errors.email}" name="email" id="email" v-model="newUser.email" placeholder="π.χ. giannis.karagiannis@gmail.com" requireda>
          <div class="invalid-feedback" v-if="errors.email">{{ errors.email[0] }}</div>
        </div>

        <div class="has-validation mb-3">
          <label for="tel" class="form-label">Κινητό τηλέφωνο</label>
          <input type="tel" class="form-control" :class="{ 'is-invalid': errors.mobile}" name="mobile" id="mobile" v-model="newUser.mobile" placeholder="π.χ. 69XXXXXXXX" required>
          <div class="invalid-feedback" v-if="errors.mobile">{{ errors.mobile[0] }}</div>
        </div>

        <button type="submit" class="btn btn-success" @click="addUser">Αποθήκευση</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      errors: {},
      newUser: {
        first_name: '',
        last_name: '',
        email: '',
        mobile: '',
      },
      selectedUserId: null,
      users: []
    };
  },
  methods: {
    addUser: function() {
      axios.post("/users/create", {
          first_name: this.newUser.first_name,
          last_name: this.newUser.last_name,
          email: this.newUser.email,
          mobile: this.newUser.mobile
      })
      .then((response) => {
        const data = response.data;

        if (data.created == true) {
          this.hideCanvas();
          this.fetchUsers();
          this.newUser.first_name = '';
          this.newUser.last_name = '';
          this.newUser.email = '';
          this.newUser.mobile = '';
        }
      })
      .catch(response => {
        const err = response.response.data.errors;

        if (err !== undefined) {
          this.errors = err;
        }
      });
    },

    confirmDelete: function(id) {
      this.selectedUserId = id;
      var modalToggle = new bootstrap.Modal(document.getElementById("deleteModal"), {});
      modalToggle.show();
    },

    confirmReactivate: function(id) {
      this.selectedUserId = id;
      var modalToggle = new bootstrap.Modal(document.getElementById("reactivateModal"), {});
      modalToggle.show();
    },

    deleteSelectedUser: function() {
      // Find index of selected user in users array
      var index = this.users.findIndex((user) => user.id == this.selectedUserId);

      if (index !== -1) {
        this.users.splice(index, 1);
        return true;
      }
      return false;
    },

    deleteUser: function() {
      axios.post("/users/delete", {
          id: this.selectedUserId
      })
      .then((response) => {
          const data = response.data;

          if (data == true) {
            this.deleteSelectedUser();
          }
      });
    },

    fetchUsers: function() {
        axios.get('/users/fetch')
            .then((response) => {
              this.users = response.data;
        });
    },

    hideCanvas: function() {
      let userOffcanvas = document.getElementById('userOffcanvas')
      let bsUserOffcanvas = bootstrap.Offcanvas.getInstance(userOffcanvas);
      bsUserOffcanvas.hide();
    },

    reactivateUser: function() {
      axios.post("/users/reactivate", {
          id: this.selectedUserId
      })
      .then((response) => {
          this.fetchUsers();
      });
    },

  },
  mounted() {
    this.fetchUsers();
  },
}
</script>
